import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/button";
import { openInNewTab } from "../../util";

import "./app-store-links.css";

export function AppStoreLinks(): JSX.Element {
  const { t } = useTranslation();

  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.healthyminds&hl=en_US&gl=US";
  const APP_STORE_URL =
    "https://apps.apple.com/us/app/healthy-minds-program/id1326310617";

  return (
    <div className="app-installation-links">
      <Button
        text={t("widgets.downloadAppStore")}
        onPress={() => openInNewTab(APP_STORE_URL)}
        buttonStyle="OPAQUE"
      />
      <Button
        text={t("widgets.downloadPlayStore")}
        onPress={() => openInNewTab(PLAY_STORE_URL)}
        buttonStyle="OUTLINE"
      />
    </div>
  );
}
